import { useQuery } from "@tanstack/react-query";
import { getPageById } from "../../api/apiPages";

export const useGetPageById = (id) => {
    const { data: page, isLoading, error } = useQuery({
        queryKey: ['page', id],
        queryFn: () => getPageById(id),
        enabled: !!id,
    });

    return { page, isLoading, error };
};
